module.exports = __webpack_public_path__ + "img/multidispositivo.92481206.svg";